import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Grid, Badge, Tooltip } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from 'utils'
import { onMobileNavToggle } from "redux/actions/Theme";
import Utils from "utils";
import "./MenuContent.css"
import { WarningFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;


const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

/*const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};*/

const SideNavContent = (props) => {
  const { sideNavTheme, routeInfo, hideGroupTitle, localization, onMobileNavToggle, menu_entries_count, menu_entries_statuses} = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')

  const [state, setState] = useState({/* firstTime: true,*/ lastPath: '' });

  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false)
    }
  }

  let defaultOpenKeys = []//setDefaultOpen(routeInfo?.key);

  navigationConfig.map((menu) => {
    if (menu.defaultOpen) {
      defaultOpenKeys.push(menu.key)
    }
    if(menu.submenu?.length > 0)
    {
      menu.submenu?.map((submenu) => {
        defaultOpenKeys.push(submenu.key)
        return true;
      })
    }
    return true;
  });

  let currentKey = routeInfo?.parentKey !== undefined ? routeInfo.parentKey : routeInfo?.key
  
  let defaultSelectedKeys = [];//[currentKey]

  navigationConfig.map((menu) => {
    if (menu.key === currentKey) {
      defaultSelectedKeys.push(menu.key)
    }
    if(menu.submenu?.length > 0)
    {
      menu.submenu?.map((submenu) => {
        if(submenu.key === currentKey)
        {
          defaultSelectedKeys.push(menu.key)
          defaultSelectedKeys.push(submenu.key)
        }
        if(submenu.submenu?.length > 0)
        {
          submenu.submenu?.map((subMenuThird) => {
            if(subMenuThird.key === currentKey)
            {
              defaultSelectedKeys.push(menu.key)
              defaultSelectedKeys.push(submenu.key)
              defaultSelectedKeys.push(subMenuThird.key)
            }
            return true;
          })
        }
        return true;
      })
    }
    return true;
  });

  if (state.firstTime) {
    setState({ ...state, firstTime: false })
  }

  //STEFANO: Commentato 24/01, venivano fatte troppe chiamate
  /*useEffect(() => {
    if (routeInfo?.key !== state.lastPath) {
      setState({ ...state, lastPath: routeInfo?.key });
      SamacLib.ReloadSessionData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeInfo?.key])*/

  let childAreAccessible = (menu) => {
    let rv = false;
    if(menu.submenu.length > 0)
    {
      menu.submenu.map(sub => {
        if(Utils.canShowNav(sub.key))
        {
          rv = true;
        }
        return true;
      })
    }
    else
    {
      rv = true;
    }
    return rv;
  }

  return (
    //alert(JSON.stringify(defaultSelectedKeys)) &&
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0, marginBottom: "10rem" }}
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={defaultSelectedKeys}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navigationConfig.map((menu, idx) =>
        !menu.hidden && Utils.canShowNav(menu.key) && (
          menu.isSeparator && childAreAccessible(menu) ? (
            <SubMenu
              icon={
                menu.iconFA ? <FontAwesomeIcon icon={menu.iconFA} style={{fontSize:"16px"}}/> : 
                menu.icon ? (
                  <Icon type={menu?.icon} />
                ) : null
              }
              style={{ color: defaultSelectedKeys.indexOf(menu.key) < 0 ? "rgb(153, 171, 180)" : "" }}
              key={menu.key}
              title={setLocale(localization, menu.title)}
            >
              {menu.submenu.map((subMenuSecond) => !subMenuSecond.hidden && Utils.canShowNav(subMenuSecond.key) && (
                subMenuSecond?.submenu?.length > 0 ?
                  <SubMenu
                    icon={
                      subMenuSecond.icon ? (
                        <Icon type={subMenuSecond?.icon} />
                      ) : null
                    }
                    style={{ color: defaultSelectedKeys.indexOf(subMenuSecond.key) < 0 ? "rgb(153, 171, 180)" : "" }}
                    key={subMenuSecond.key}
                    title={setLocale(localization, subMenuSecond.title)}
                  >
                    {subMenuSecond?.submenu?.map((subMenuThird) => !subMenuThird.hidden && Utils.canShowNav(subMenuThird.key) &&
                      (
                        <Menu.Item key={subMenuThird.key}>
                          {subMenuThird.icon ? (
                            <Icon type={subMenuThird?.icon} />
                          ) : null}
                          <span>
                            {setLocale(localization, subMenuThird.title)}
                          </span>
                          <Link onClick={() => closeMobileNav()} to={subMenuThird.path} >
                            &nbsp;&nbsp;&nbsp;&nbsp;<Badge className="menu-badge" count={menu_entries_count !== undefined ? menu_entries_count[subMenuSecond.key] : 0} size="small" style={{
                              boxShadow: "none"
                            }} /></Link>
                        </Menu.Item>
                      )
                    )}
                  </SubMenu>
                  :
                  <Menu.Item key={subMenuSecond.key}>
                    {subMenuSecond.icon ? (
                      <Icon type={subMenuSecond?.icon} />
                    ) : null}
                    <span>
                      {setLocale(localization, subMenuSecond.title)}
                    </span>
                    <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} >
                      {menu_entries_count !== undefined && menu_entries_count[subMenuSecond.key] !== undefined && <>
                        &nbsp;&nbsp;&nbsp;&nbsp;<Badge className="menu-badge" count={menu_entries_count !== undefined ? menu_entries_count[subMenuSecond.key] : 0} size="small" style={{
                          boxShadow: "none"
                        }} /></>}
                      
                      </Link>
                      {subMenuSecond.key === "reports_list" && menu_entries_statuses !== undefined && menu_entries_statuses.has_notclosed_reports  && 
                        <Tooltip placement="right" overlayStyle={{maxWidth: '210px'}} title="Presenti rapportini non chiusi più vecchi di 2 giorni ">
                          <span style={{marginLeft: ".1rem"}}><WarningFilled style={{color: "gold", fontSize: ".8rem", position:"relative", zIndex: "999"}}/></span>
                        </Tooltip>
                      }
                  </Menu.Item>
              ))}
            </SubMenu>
          ) : (
            <Menu.Item
              className="no-before"
              key={menu.key}
              style={{ marginTop: (String(menu.path).indexOf(routeInfo?.key) && menu.key === "dashboard") ? "1.5rem" : "" }}
            >
              {menu.icon ? <Icon type={menu?.icon} /> : null}
              <span>{setLocale(localization, menu?.title)}</span>

              {menu.key === "reports" && menu_entries_statuses !== undefined && menu_entries_statuses.has_notclosed_reports  && 
                <Tooltip placement="right" overlayStyle={{maxWidth: '210px'}} title="Presenti rapportini non chiusi più vecchi di 2 giorni ">
                  <span style={{marginLeft: ".8rem"}}><WarningFilled style={{color: "gold", fontSize: ".8rem", position:"relative", zIndex: "999"}}/></span>
                </Tooltip>
              }

              {menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
              
            </Menu.Item>
          )
        )
      )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme, session }) => {
  const { sideNavTheme, topNavColor } = theme;
  const { menu_entries_count, menu_entries_statuses } = session;
  return { sideNavTheme, topNavColor, menu_entries_count, menu_entries_statuses };
};


export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
